<div class="assign-assistant-wrapper">
    <div *ngIf="loading" class="loader">
        <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
    </div>
    <div class="title">
        {{'edit-assistant.assign-assistant.title' | translate}}
    </div>
    <div class="stud-card-wrapper">
        <div class="img-container">
            <img [src]="baseUrl + config?.data?.student_image " alt="">
        </div>
        <div class="stud-info-container">
            <div class="name-container">
                <div class="label">
                    {{'edit-assistant.assign-assistant.student_name' | translate}}
                </div>
                <div class="value">
                    {{config?.data?.name}}
                </div>
            </div>
            <div class="national-id-container">
                <div class="label">
                    {{'edit-assistant.assign-assistant.student_id' | translate}}
                </div>
                <div class="value" data-pii="redact">
                    {{config?.data?.national_id}}
                </div>
            </div>
        </div>
    </div>
    <div class="assign-container">
        <form [formGroup]="assignAssistantForm">
            <div class="field-wrapper">
                <mat-form-field appearance="outline" dir="ltr">
                    <mat-label>{{'edit-assistant.assistant-name' | translate}}</mat-label>
                    <input matInput formControlName="name" [readonly]="assistantExistsInSystem">
                    <mat-error>{{getAssistantFormValidation('name')}}</mat-error>
                </mat-form-field>
            </div>

            <div class="field-wrapper">
                <div class="id">
                    <mat-form-field appearance="outline" class="national-id" dir="ltr">
                        <mat-label>{{'edit-assistant.id-number' | translate}}</mat-label>
                        <input matInput formControlName="national_id" data-pii="redact">
                        <mat-error>{{getIDErrorMessage()}}</mat-error>
                    </mat-form-field>
                </div>

                <div class="check">
                    <img matTooltip={{getSerachByIdLabel()}} src="../../../assets/icons/search ID.svg"
                        class="search-img" (click)="searchById()">
                </div>
            </div>

            <div class="field-wrapper">
                <mat-form-field appearance="outline" dir="ltr">
                    <mat-label>{{'edit-assistant.gender' | translate}}</mat-label>
                    <mat-select formControlName="gender" [disabled]="assistantExistsInSystem">
                        <mat-option value="female">
                            {{'user-management.parents.female' | translate}}</mat-option>
                        <mat-option value="male">
                            {{'user-management.parents.male' | translate}}</mat-option>
                    </mat-select>
                    <mat-error>{{'user-management.error-msgs.gender-required' | translate}}</mat-error>
                </mat-form-field>
            </div>

            <div class="field-wrapper">
                <div class="code">
                    <mat-form-field appearance="outline" dir="ltr">
                        <mat-label>{{'edit-assistant.code' | translate}}</mat-label>
                        <mat-select formControlName="country_code" [disabled]="assistantExistsInSystem">
                            <ng-container *ngFor="let country of countries">
                                <mat-option *ngIf="country.selected" [value]="country?.code_plus">
                                    <table [ngStyle]="{'direction': lang == 'ar' ? 'rtl' : 'ltr'}">
                                        <tr>
                                            <td>
                                                <img style="margin-inline-end:5px;" [src]="country?.flag"
                                                    [alt]="country?.short"
                                                    [title]="lang == 'ar'? country?.name_ar : country?.name">
                                            </td>
                                            <td>
                                                <!-- +{{country?.code | arabicNumber: lang}} translate code -->
                                                {{country?.code_plus}}
                                            </td>
                                        </tr>
                                    </table>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                        <mat-error>{{'user-management.error-msgs.code-required' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="phone">
                    <mat-form-field appearance="outline" dir="ltr">
                        <mat-label>{{'edit-assistant.phone' | translate}}</mat-label>
                        <input matInput formControlName="phone" [readonly]="assistantExistsInSystem" data-pii="redact">
                        <mat-error>{{getAssistantFormValidation('phone')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="field-wrapper">
                <mat-form-field appearance="outline" dir="ltr">
                    <mat-label>{{'edit-assistant.email' | translate}}</mat-label>
                    <input matInput formControlName="email" [readonly]="assistantExistsInSystem">
                    <mat-error>{{getAssistantFormValidation('email')}}</mat-error>
                </mat-form-field>
            </div>
        </form>
    </div>
    <div class="footer">
        <button *ngIf="config?.mode === 'add'" [disabled]="assignAssistantForm.invalid"
            (click)="saveAssistant()" class="btn btn-primary save-btn">{{'user-management.save'|translate}}</button>
    </div>
</div>